import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { REFERRAL_WON } from '../../../paths/defaultImage';
import StarRating from '../../common/starRating';
import { MenuCategoryContext } from '../menu';
import LazyImage from '../../common/lazyLoad';
function RestaurantHeader({ name, serviceableText, restaurantRating, restaurantAddress, cuisine }) {
  const restaurantConfig = useSelector((store) => store.restSetting?.Setting);
  const { referrerCode } = useContext(MenuCategoryContext);
  const resCover = restaurantConfig?.menu_cover_img;
  const { t } = useTranslation();

  const getHeaderText = () => {
    let headerText;
    if (restaurantConfig.status == 2) headerText = t('currently_not');
    if (serviceableText && restaurantConfig.status == 1) headerText = serviceableText;

    if (headerText) return <div className='header-text fs-12 py-1 px-2 fw-600'>{headerText}</div>;
    return null;
  };
  const headerText = getHeaderText();
  return (
    <div
      className={`d-flex flex-column restaurant-header ${resCover ? 'p-20' : 'px-20'} ${
        headerText ? 'pt-2' : ''
      } ${
        !!referrerCode?.coupon_limit?.customer_coupons && !resCover ? 'pt-2' : ''
      } pb-2 gap-1 appSubHeader`}>
      {resCover && <div className='fs-20 fw-700'>{name}</div>}

      {resCover && (
        <div className='d-flex fs-14 fw-500 gap-1'>
          {restaurantRating > 3 ? (
            <>
              <StarRating rating={restaurantRating} />|{' '}
            </>
          ) : null}
          <span className='line-clamp-1'>{!!cuisine.length && `${cuisine.join(', ')}`}</span>
        </div>
      )}

      {headerText}
      {!!referrerCode?.coupon_limit?.customer_coupons && (
        <div className='referral-won'>
          <LazyImage src={REFERRAL_WON} height={22} width={22} />
          {t('you_have_been_awarded')}{' '}
          {referrerCode.coupon_limit.customer_coupons == 1
            ? `${referrerCode.coupon_limit.customer_coupons} ${t('time')}`
            : `${referrerCode.coupon_limit.customer_coupons} ${t('times')}`}
        </div>
      )}
    </div>
  );
}
export default RestaurantHeader;
